import { BusinessRulesClient } from "../client/procescontroleclient";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { NavLink, useNavigate } from "react-router-dom";

import themeColors from "../config/themeColors";
import Button from "../components/UI/Button";
import Table from "../components/tables/Table";
import PageTitle from "../components/UI/PageTitle";
import { ButtonType, TableType } from "../Types"

const getRowColorByDates = (startDate: Date | undefined, endDate: Date | undefined): string => {
    const now = moment();
    const start = moment(startDate);
    const end = moment(endDate);
    if(now.isBetween(start, end)) {
        return themeColors.ftgGreen;
    }
    return '#fff3cd';
}

export function BusinessRuleOverview() {
    const navigate = useNavigate();
    const client = new BusinessRulesClient(process.env.REACT_APP_APIURL);
    const {data: businessRules} = useQuery(['businessRules', 'all'], () => client.getBusinessRules(), {staleTime: Infinity});

    return (
        <div>
            <PageTitle>Business Rules</PageTitle>
            <div>
                <Table tableType={TableType.Default} stickymodal>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>OrderStatus</th>
                            <th>Startdatum</th>
                            <th>Einddatum</th>
                            <th>Waarde</th>
                        </tr>
                    </thead>
                    <tbody>
                        {businessRules?.map(businessRule => (
                            <tr key={businessRule.id} style={{ backgroundColor: getRowColorByDates(businessRule.startDate, businessRule.endDate) }}>
                                <td><NavLink to={'/editbusinessrule/' + businessRule.id} state={businessRule}>{businessRule.id}</NavLink></td>
                                <td>{businessRule.orderStatusId}</td>
                                <td>{moment(businessRule.startDate).format('YYYY-MM-DD [om] HH:mm')}</td>
                                <td>{moment(businessRule.endDate).format('YYYY-MM-DD [om] HH:mm')}</td>
                                <td>{businessRule.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Button buttonType={ButtonType.Secondary} onClick={() => navigate('/createbusinessrule')}>Create new business rule</Button>
        </div>
    );
}
export default BusinessRuleOverview;